import { useState, useEffect, createContext } from 'react';
import { Reactive, useReactor } from '@livefree/reactive';
import { useSearchParams, useNavigate } from 'react-router';
import { RoutePaths } from '@/routing/RoutePaths';
import { reactive } from '@/core/reactive/reactive';

export const PasswordContext = createContext();

export const PasswordProvider = reactive.component(
  ({ services, children }) => {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const token = params.get('token');

    const [info, setInfo] = useState({
      token,
      user: {},
      isSuccess: false,
      message: '',
      isReady: false,
    });

    useEffect(() => {
      services.password.info(token);
    }, [services, token]);

    useReactor(
      services.password.info,
      {
        success: response => {
          setInfo(x => ({ ...x, ...response.payload, isReady: true }));
        },
        error: response => {
          setInfo(x => ({ ...x, ...response.payload, isReady: true }));
        },
      },
      [],
    );

    useReactor(services.password.setPassword, {
      success: response => {
        if (!response.payload.isSuccess) {
          setInfo(x => ({ ...x, ...response.payload, isReady: true }));
        } else {
          navigate(RoutePaths().root());
        }
      },
      error: response => {
        setInfo(x => ({ ...x, ...response.payload, isReady: true }));
      },
    });

    return <PasswordContext.Provider value={info}>{children}</PasswordContext.Provider>;
  },
  {
    name: 'PasswordProvider',
  },
);
